// @ts-nocheck
import styled, { css } from 'styled-components';
import { error, scarpaGray400, scarpaGray800, spanishViridian25, spanishViridian500 } from '@habitech/shared';
import { GridContainer } from 'src/components/common/grids';

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: ${scarpaGray800};
`;

export const SearchWrapper = styled(GridContainer)`
    padding: 32px 0;
    align-items: baseline;
`;

export const TextBasic = css`
    font-size: 16px;
    margin: 16px 0;
`;

export const Text = styled.div`
    ${TextBasic}
    color: ${scarpaGray400};
`;

export const ErrorText = styled.div`
    ${TextBasic}
    color: ${error};
`;

export const EditorWrapper = styled.div`
    margin-bottom: 24px;
    .description-editor {
        h2 {
            margin-bottom: 10px;
            font-size: 24px;
            color: ${scarpaGray800};
            font-weight: 700;
            padding: 0;
        }
        b {
            font-weight: 500;
            font-size: 14px;
        }
        a,
        p,
        li,
        ol {
            color: ${scarpaGray800};
            line-height: 24px;
            font-size: 16px;
            margin: 0;
        }
        a {
            color: ${spanishViridian500};
            font-weight: 700;
            text-decoration: none;
        }
        .ql-snow.ql-toolbar {
            border-radius: 6px 6px 0 0;
            background: ${spanishViridian25};
            button:hover,
            button.ql-active,
            .ql-picker-label.ql-active,
            .ql-picker-item:hover,
            .ql-picker-label:hover,
            .ql-picker-label:hover .ql-stroke {
                color: ${spanishViridian500};
            }
            button:hover .ql-fill,
            button.ql-active .ql-fill {
                fill: ${spanishViridian500};
            }
            button:hover .ql-stroke,
            button.ql-active .ql-stroke,
            .ql-picker-label.ql-active,
            .ql-picker-label.ql-active .ql-stroke {
                stroke: ${spanishViridian500};
            }
        }
        .ql-tooltip a {
            color: ${spanishViridian500};
            font-weight: 500;
        }
        .ql-snow .ql-tooltip::before {
            content: 'ir a Url';
        }
        .ql-tooltip.ql-editing a.ql-action::after {
            content: 'Guardar';
        }
        .ql-tooltip a.ql-action::after {
            content: 'Editar';
        }
        .ql-tooltip a.ql-remove::before {
            content: 'Eliminar';
        }
        .ql-container {
            border-radius: 0 0 6px 6px;
            .ql-editor {
                padding: 16px;
            }
        }
    }
`;
